export { default } from "./ProductInfo";
